import React from 'react';
// import ReactDOM from 'react-dom';
import { createRoot } from 'react-dom/client'
import './index.css';

// import '../node_modules/bootstrap/dist/css/bootstrap.css'
import App from './App';


import { AuthContextProvider } from './context/AuthContext'
import { ProductsProvider } from './context/products.context'
import { SelectedFiltersProvider } from './context/selectedFilters.context'

// ReactDOM.render(
//   <React.StrictMode>
//     <App />
//   </React.StrictMode>,
//   document.getElementById('root')
// );

const container = document.getElementById('root')
const root = createRoot(container)
root.render(

<AuthContextProvider>
      <SelectedFiltersProvider>
      <ProductsProvider>
    <App />
      </ProductsProvider>
      </SelectedFiltersProvider>
    </AuthContextProvider>

)
